/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import DateSelect from './DateSelect/index'
import React from 'react'
import SlotSelect from './SlotSelect/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/ScheduleOptions/Content"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<DateSelect
  viewPath={`${viewPath}/DateSelect`}
/>
<SlotSelect
  viewPath={`${viewPath}/SlotSelect`}
/>
</div>
{children}
</React.Fragment>)
}